module.exports = __webpack_public_path__ + "a163ed739d23da79da9f409bb5f86afd.png";